export default __webpack_public_path__ + "static/media/btc.e92be1a1.jpg";